import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "@/app/App";
import "@/store/styleStore"; // applies the saved visual style before first paint
import "@/index.css";

// Strip the trailing slash so React Router's basename matches both "/" (root)
// and "/Hippo" (the GitHub Pages subpath).
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
